"use strict";

var _themeSections = require("@shopify/theme-sections");

var _flickityImagesloaded = _interopRequireDefault(require("flickity-imagesloaded"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Featured blog posts
 * ------------------------------------------------------------------------------
 *
 * @namespace featuredBlogPosts
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-featured-blog-posts="container"]',
  carousel: '[js-featured-blog-posts="carousel"]',
  cell: '[js-featured-blog-posts="slide"]'
};
/**
 * Instance globals.
 */

var carouselSlider = {};
/**
 * Register a single featured blog post section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('featured-blog-posts', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"]");
    var carousel = "".concat(container, " ").concat(selectors.carousel);
    var cells = "".concat(container, " ").concat(selectors.cell);
    this.cache = {
      container: container,
      carousel: carousel,
      cells: cells
    };
  },

  /**
   * Check if the section exist.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel using imported Carousel.
   */
  constructCarousel: function constructCarousel() {
    carouselSlider = new _flickityImagesloaded["default"](this.cache.carousel, {
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      pageDots: false,
      prevNextButtons: false,
      watchCSS: true
    });
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }
});